var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9846 18.8236C25.8064 19.029 26.3264 19.7838 26.2408 20.6452L25.9829 23.3529C25.8451 25.6466 24.2728 26.528 22.2808 26.1747C12.4436 24.9722 5.02017 17.5635 3.81408 7.71807C3.25015 3.66921 6.51676 4.0825 9.34659 3.76021C10.2138 3.66935 10.962 4.19279 11.1676 5.01412L11.8772 7.83446C12.0774 8.75364 12.6099 9.85904 11.9025 10.7576L10.7067 12.7914C10.4641 13.1362 10.42 13.5336 10.5756 13.86C11.7576 16.3337 13.6548 18.2511 16.0849 19.441C16.4062 19.6019 16.8105 19.561 17.124 19.3368L19.2679 18.0691C20.142 17.387 21.2633 17.9204 22.1712 18.1157L24.9846 18.8236Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.2ad6e6e3bd24313f1aef8aacd2e4f116.svg";
export { ForwardRef as ReactComponent };